import React, { useState, useEffect, useCallback } from 'react';
import CustomButton from '../../shared-components/Button/custom-button';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from "react-bootstrap";
import { Calendar } from 'primereact/calendar';
import { Form, Dropdown, Card, Badge } from "react-bootstrap";
import './design.css';
import { loadToaster } from '../../shared-components/toaster/toaster-actions-creators';
import { useDispatch } from 'react-redux';

const DisplayLogicQuestion = React.forwardRef((props, ref) => {
    const dispatch = useDispatch();
    const { newList, operators, question, onChange, saveDLForEachQuestion, onDLDirtyChange } = props;
    const [conditions, setConditions] = useState([]);
    const [showdLText, setShowdLText] = useState('');
    const [showVisibleIfText, setShowVisibleIfText] = useState('');
    const [anyChange, setAnyChange] = useState(false);
    const [isDLValidated, setIsDLValidated] = useState(true);
    const logicalOperators = [
        { text: 'And', value: 'and' },
        { text: 'Or', value: 'or' },
    ];
    const [selectedUpdatedQuestion, setSelectedUpdatedQuestion] = useState(null);
    // Notify parent if display logic is dirty (changed but not validated)
    useEffect(() => {
        if (typeof onDLDirtyChange === 'function') {
            onDLDirtyChange(anyChange);
        }
    }, [anyChange, onDLDirtyChange]);

    // Expose a method to reset validation state from parent
    React.useImperativeHandle(ref, () => ({
        resetDLValidation: () => setIsDLValidated(true),
        setDLDirty: () => setIsDLValidated(false),
        isDLDirty: () => anyChange
    }));

    useEffect(() => {
        const parseDLFormulaText = (DLFormulaText) => {
            const conditions = [];

            const regex = /(?:\((.*?)\)|{([^}]*)})\s*([><=!]+)\s*((?:\[.*?\]|[\w'-]+))(?:\s+(and|or)\s*)?/g;

            let match;
            while ((match = regex.exec(DLFormulaText)) !== null) {
                const tempId = match[2] || match[1];
                const operator = match[3];
                let option = match[4];
                const logicalOperator = match[5] !== undefined ? ` ${match[5]} ` : '';

                if (option.startsWith('[') && option.endsWith(']')) {
                    option = option.slice(1, -1).split(',').map(item => item.trim());
                }

                const selectedQuestion = newList.find((item) => item.tempId === tempId);
                conditions.push({
                    selectedTempID: tempId,
                    selectedOperator: operator,
                    selectedOption: option,
                    selectedLogicalOperator: logicalOperator.trim(),
                    selectedQuestion: selectedQuestion,
                });
            }

            setConditions(conditions);
        };

        if (question.DLFormulaText) {
            parseDLFormulaText(question.DLFormulaText);
        }
    }, [question.DLFormulaText, newList]);

    useEffect(() => {
        const updateDLFormulaText = () => {
            const DLFormulaText = conditions
                .map((condition, index) => {
                    const {
                        selectedTempID,
                        selectedOperator,
                        selectedOption,
                        selectedLogicalOperator,
                    } = condition;

                    if (selectedTempID && selectedOperator) {
                        const logicalOperator = selectedLogicalOperator ? ` ${selectedLogicalOperator} ` : '';

                        if (Array.isArray(selectedOption)) {
                            return `{${selectedTempID}} ${selectedOperator} [${selectedOption.map((option) => `${option}`).join(',')}]${logicalOperator}`;
                        } else {
                            return `{${selectedTempID}} ${selectedOperator} ${selectedOption}${logicalOperator}`;
                        }
                    }

                    return '';
                })
                .filter((condition) => condition !== '')
                .join(' ');

            const updatedQuestion = {
                ...question,
                DLFormulaText: DLFormulaText ? `(${DLFormulaText})` : '',
            };
            setShowdLText(updatedQuestion.DLFormulaText);
            // if (updatedQuestion.visibleIf === '') {
            //     setShowVisibleIfText(updatedQuestion.DLFormulaText);
            // }
            // else {
            //     setShowVisibleIfText(updatedQuestion.visibleIf);
            // }
            setShowVisibleIfText(updatedQuestion.DLFormulaText);

            setSelectedUpdatedQuestion(updatedQuestion);
        };

        updateDLFormulaText();
    }, [conditions, question]);

    const handleAddCondition = () => {
        setConditions([...conditions, {}]);
    };
    const handleSelectChange = (event, index) => {
        const selectedTempId = event.target.value;
        const selectedObj = newList.find((item) => item.tempId === selectedTempId);

        let isQuestionAdded = false; // Flag to track if the question has already been added

        setConditions((prevConditions) => {
            const updatedConditions = [...prevConditions];
            const existingObjIndex = updatedConditions.findIndex(
                (obj) =>
                    obj.selectedQuestion &&
                    obj.selectedQuestion.tempId === selectedTempId &&
                    (obj.selectedQuestion.type === "radiogroup" ||
                        obj.selectedQuestion.type === "checkbox" ||
                        obj.selectedQuestion.type === "selectList" ||
                        obj.selectedQuestion.type === "ranking" ||
                        obj.selectedQuestion.type === "singleDropdown" ||
                        obj.selectedQuestion.type === "multiselectdropdown")
            );
            if (existingObjIndex !== -1) {
                updatedConditions.pop(); // Remove the last empty object if it exists
                dispatch(
                    loadToaster({
                        type: "warn",
                        title: "",
                        msg: "Question Already Added",
                    })
                );
                isQuestionAdded = true; // Set the flag to true
            }

            // Update the condition only if the question hasn't been added
            if (!isQuestionAdded) {
                updatedConditions[index] = {
                    ...updatedConditions[index],
                    selectedTempID: selectedTempId,
                    selectedOperator: "",
                    selectedOption: "",
                    selectedLogicalOperator: "",
                    selectedQuestion: selectedObj,
                };
            }

            return updatedConditions;
        });

        setAnyChange(true);
    };
    const handleOptionChange = (index, value) => {
        setConditions((prevConditions) => {
            const updatedConditions = [...prevConditions];
            updatedConditions[index] = {
                ...updatedConditions[index],
                selectedOption: value,
            };
            return updatedConditions;
        });
        setAnyChange(true);
    };

    const handleOperatorChange = (event, index) => {
        const { value } = event.target;
        setConditions((prevConditions) => {
            const updatedConditions = [...prevConditions];
            updatedConditions[index] = { ...updatedConditions[index], selectedOperator: value };
            return updatedConditions;
        });
        setAnyChange(true);
    };

    const handleLogicalOperatorChange = (event, index) => {
        const { value } = event.target;
        setConditions((prevConditions) => {
            const updatedConditions = [...prevConditions];
            updatedConditions[index] = { ...updatedConditions[index], selectedLogicalOperator: value };
            return updatedConditions;
        });
        setAnyChange(true);

    };

 const handleDeleteCondition = (index) => {
    console.log("Deleting condition at index:", index);
    setConditions((prevConditions) => {
        return prevConditions.filter((_, i) => i !== index);
    });
    setAnyChange(true);
};



    function validateConditions(conditions, text) {
   if (!conditions || conditions.length === 0) {
    return { status: true, message: 'No conditions. Display logic cleared.' };
}


    const lastCondition = conditions[conditions.length - 1];

    // Safely check logical operator
    if (!lastCondition || lastCondition.selectedLogicalOperator === '') {
        for (let i = 0; i < conditions.length - 1; i++) {
            const condition = conditions[i];
            for (const prop in condition) {
                if (!condition[prop]) {
                    return { status: false, message: `Invalid condition. '${prop}' is empty.` };
                }
            }
        }

        // Parentheses balance check
        const parenthesesStack = [];
        for (const char of text) {
            if (char === '(') parenthesesStack.push('(');
            else if (char === ')') {
                if (parenthesesStack.length === 0) {
                    return { status: false, message: 'Invalid condition. Unbalanced parentheses.' };
                }
                parenthesesStack.pop();
            }
        }

        if (parenthesesStack.length !== 0) {
            return { status: false, message: 'Invalid condition. Unbalanced parentheses.' };
        }

        return { status: true, message: 'Conditions array and text are valid.' };
    } else {
        return { status: false, message: 'Invalid condition. Please check the logical operator.' };
    }
}


    const handleSaveDL = () => {
        const { status: isFine, message } = validateConditions(conditions, showVisibleIfText);
        if (isFine === false) {
            dispatch(loadToaster({ type: 'warn', title: 'Validation Failed', msg: message }))
        }
        else {
            let obj = { ...selectedUpdatedQuestion };
            obj.DLFormulaText = showdLText;
            obj.visibleIf = showVisibleIfText;
            saveDLForEachQuestion(obj);
            setAnyChange(false);
        }

    };
    function findStringDifference(str1, str2) {
        let difference = '';
        const maxLength = Math.max(str1.length, str2.length);

        for (let i = 0; i < maxLength; i++) {
            if (str1[i] !== str2[i]) {
                if (str2[i] === '(' || str2[i] === ')') {
                    difference += str2[i];
                } else {
                    break; // Stop comparing if non-parentheses character is encountered
                }
            }
        }

        return difference;
    }
    const handleDLInputChange = (e) => {
        const inputValue = e.target.value;
        const difference = findStringDifference(showVisibleIfText, inputValue);

        if (difference === "(" || difference === ")") {
            setShowVisibleIfText(inputValue);
        } else if (difference === "" && inputValue.length < showVisibleIfText.length) {
            setShowVisibleIfText(inputValue);
        }
    };

    return (
        <div style={{ marginTop: '5px' }}>
                     
<div className="alert alert-info d-flex flex-column gap-2">
      <div className="d-flex align-items-start">
        <i className="pi pi-info-circle text-primary me-2 mt-1"></i>
        <span>Changing the order or deletion of selected question will reset the display logic.</span>
      </div>
      <div className="d-flex align-items-start">
        <i className="pi pi-info-circle text-primary me-2 mt-1"></i>
        <span>
          If you change anything in display logic, you have to click on
          <b className="ms-1">Save Display Logic</b>.
        </span>
      </div>
    </div>

    {/* Header Row */}
  <div className="row mb-3 align-items-center">
  <div className="col-md-9 col-12 mb-2 mb-md-0">
    <div className="d-flex flex-column">
      <span className="fw-bold">Display Logic For the current question :</span>
      <span className="fw-bold">
        {question.tempId + ". "}{question.questionText}
      </span>
    </div>
  </div>
  <div className="col-md-3 col-12 d-flex justify-content-md-end justify-content-start">
    <CustomButton
      name="Save"
      label="Save Display Logic"
      className={`custom-primary-button validate-btn ${isDLValidated ? "validated" : "not-validated"}`}
      icon="pi pi-save"
      onClick={handleSaveDL}
      disabled={!anyChange}
      style={{ whiteSpace: "nowrap", minWidth: "fit-content" }} // 👈 prevents breaking
    />
  </div>
</div>



            <span>Validated Display Logic   : <span style={{ 'fontWeight': 'bold' }}>{selectedUpdatedQuestion && selectedUpdatedQuestion?.visibleIf}</span></span>

            <div className="row">
                <div className="col-2">
                    <span>Display Logic:</span>
                </div>
                <div className="col-10">
                    <InputTextarea
                        style={{
                            'fontSize': 'normal',
                            'minWidth': '100%',
                            maxWidth: 'fit-content',
                            marginRight: '5px',
                        }}
                        rows={2}
                        autoResize={true}
                        value={showVisibleIfText}
                        onChange={handleDLInputChange}

                    />
                </div>
            </div>
            <div className="mb-2 mt-1" style={{
                backgroundColor: 'black',
                height: 2
            }}></div>
            {conditions.map((condition, index) => {
                const uniqueId = `${condition.selectedTempID}-${index}`; // Generate a unique ID

                const handleOptionChangeForIndex = (event, index) => {
                    handleOptionChange(parseInt(index), event); // Convert the index to an integer
                };

                return (
                    <div key={uniqueId}>
                        <div className="row" style={{ marginBottom: '5px' }}>
                            <div className="col-7">
                                <label className="tab-view-label" style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '3px' }} htmlFor={`questionDropdown_${uniqueId}`}>
                                    Select a question:
                                </label>
                                <select
                                    id={`questionDropdown_${uniqueId}`}
                                    className="form-select"
                                    value={condition.selectedTempID || ''}
                                    onChange={(event) => handleSelectChange(event, index)}
                                >
                                    <option value="">Select a question</option>
                                    {newList.map((item) => (
                                        <option key={item.tempId} value={item.tempId}>
                                            {item.tempId + '. ' + item.questionText}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {condition.selectedTempID && (
                                <div className="col-3">
                                    <label className="tab-view-label" style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '3px' }} htmlFor={`operatorDropdown_${uniqueId}`}>
                                        Select an operator:
                                    </label>
                                    <select
                                        id={`operatorDropdown_${uniqueId}`}
                                        className="form-select"
                                        value={condition.selectedOperator || ''}
                                        onChange={(event) => handleOperatorChange(event, index)}
                                    >
                                        <option value="">Select an operator</option>
                                        {operators.map((item) => (
                                            <option key={item.value} value={item.value}>
                                                {item.text}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            <div className="col-2 align-self-center mt-4">
                                <CustomButton
                                    name="RemoveOption"
                                    label=""
                                    className="p-button-danger margin-right"
                                    icon="pi pi-times"
                                    style={{
                                        backgroundColor: '#7c38bc',
                                        borderColor: '#7c38bc',
                                        height: '30px',
                                        lineHeight: '1.5',
                                        padding: '0 0.5rem',
                                        fontSize: '1rem',
                                    }}
                                    onClick={() => handleDeleteCondition(index)}
                                />
                            </div>
                        </div>
                        {condition.selectedOperator && condition.selectedQuestion && (
                            <div className="row">
                                <div className="col-12">
                                    <div>
                                        <span className="tab-view-label" style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '3px' }}>
                                            is:
                                        </span>
                                    </div>
                                    {(() => {
                                        switch (condition.selectedQuestion.type) {
                                            case 'numeric':
                                                return <NumericOptions {...condition} onChange={(value) => handleOptionChange(index, value)} />;
                                            case 'NPS':
                                                return <NPSOptions {...condition} onChange={(value) => handleOptionChange(index, value)} />;
                                            case 'openText':
                                                return <OpenTextOptions {...condition} onChange={(value) => handleOptionChange(index, value)} />;
                                            case 'starRating':
                                                return <StarRankOptions {...condition} onChange={(value) => handleOptionChange(index, value)} />;
                                            case 'rating':
                                                return <EmojiRankOptions {...condition} onChange={(value) => handleOptionChange(index, value)} />;
                                            case 'radiogroup':
                                            case 'checkbox':
                                            case 'selectList':
                                            case 'ranking':
                                            case 'singleDropdown':
                                            case 'multiselectdropdown':
                                                return <MultiselectDropdownWithValue
                                                    {...condition} currentIndex={index}
                                                    dataIndex={index}
                                                    onChange={handleOptionChangeForIndex} // Use the new function with the current index
                                                />;
                                            case 'date':
                                                return <DateOptions {...condition} onChange={(value) => handleOptionChange(index, value)} />;
                                            case 'boolean':
                                                return <BooleanDropdown {...condition} onChange={(value) => handleOptionChange(index, value)} />;
                                            case 'sliderScale':
                                                return <SliderQuestion {...condition} onChange={(value) => handleOptionChange(index, value)} />;
                                            default:
                                                return null;
                                        }
                                    })()}
                                    <div className="col-4 align-self-center mt-3">
                                        <label className="tab-view-label" style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '3px' }} htmlFor={`logicalOperatorDropdown_${uniqueId}`}>
                                            Select a Logical Operator:
                                        </label>
                                        <select
                                            id={`logicalOperatorDropdown_${uniqueId}`}
                                            className="form-select"
                                            value={condition?.selectedLogicalOperator || ''}
                                            onChange={(event) => handleLogicalOperatorChange(event, index)}
                                        >
                                            <option value="">Select a logical operator</option>
                                            {logicalOperators.map((item) => (
                                                <option key={item.value} value={item.value}>
                                                    {item.text}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}



            <div className='row'>
                <div className='col-3 mt-3'>
                    <CustomButton
                        name="add"
                        label="Add condition"
                        className="p-button-success margin-right"
                        icon="pi pi-plus"
                        style={{
                            backgroundColor: '#7c38bc',
                            borderColor: '#7c38bc',
                            height: '30px',
                            lineHeight: '1.5',
                            padding: '0 0.5rem',
                            fontSize: '1rem',
                        }}
                        onClick={handleAddCondition}
                    />
                </div>

            </div>

        </div>
    );
});



const NumericOptions = (props) => {
    const { selectedQuestion, selectedOption, onChange } = props;

    const handleOptionChange = (event) => {
        onChange(event.target.value);
    };

    return (
        <>
            <div className="p-inputtextarea" style={{ width: '75%' }}>
                <input
                    name="numeric"
                    type="number"
                    className="p-inputtext p-component"
                    style={{ width: '100%' }}
                    value={selectedOption}
                    onChange={handleOptionChange}
                />
            </div>
        </>
    );
};
// NPS DATA
const npsData = [
    { value: '0', className: 'p-button-danger margin-right' },
    { value: '1', className: 'p-button-danger margin-right' },
    { value: '2', className: 'p-button-danger margin-right' },
    { value: '3', className: 'p-button-danger margin-right' },
    { value: '4', className: 'p-button-danger margin-right' },
    { value: '5', className: 'p-button-danger margin-right' },
    { value: '6', className: 'p-button-danger margin-right' },
    { value: '7', className: 'p-button-warning margin-right' },
    { value: '8', className: 'p-button-warning margin-right' },
    { value: '9', className: 'p-button-success margin-right' },
    { value: '10', className: 'p-button-success margin-right' }
];
// NpS Question
const NPSOptions = (props) => {
    const { selectedQuestion, selectedOption, onChange } = props;
    const handleOptionChange = (value) => {
        onChange(value);
    };

    return (
        <>
            <div className="option" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                {
                    npsData.map((element) => (
                        <CustomButton
                            key={element.value}
                            name={'nps' + element.value}
                            label={element.value}
                            className={element.className}
                            style={{ height: '40px', minWidth: '40px', margin: '0 5px' }}
                            onClick={() => handleOptionChange(element.value)}
                        />
                    ))
                }
            </div>

        </>
    )
}

// Open Text Question
const OpenTextOptions = (props) => {
    const { selectedQuestion, selectedOption, onChange } = props;
    const handleOptionChange = (event) => {
        onChange(event.target.value);
    };
    return (
        <>
            <div className="p-inputtextarea" style={{ width: '75%' }}>
                <input
                    name="numeric"
                    className="p-inputtext p-component"
                    style={{ width: '100%' }}
                    value={selectedOption}
                    onChange={handleOptionChange}
                />
            </div>
        </>
    )
}

//Emoji Question
const EmojiRankOptions = (props) => {
    const { selectedQuestion, selectedOption, onChange } = props;
    const [value, setValue] = useState(selectedOption);

    const handleRatingChange = (value) => {
        setValue(value);
        onChange(value);
    };
    const smileyList = ["😞", "😕", "😐", "😊", "😄", "😃", "🤩"];

    const renderSmileys = () => {
        const smileys = [];
        for (let i = 1; i <= selectedQuestion.rateMax; i++) {
            const index = Math.floor((i - 1) / (selectedQuestion.rateMax / smileyList.length));
            const isSelected = i === parseInt(selectedOption);
            smileys.push(
                <Button
                    key={i}
                    variant="light"
                    className={`mx-1 ${isSelected ? 'bg-primary text-white' : ''}`}
                    onClick={() => handleRatingChange(i)}
                >
                    {smileyList[index]}
                </Button>
            );
        }
        return smileys;
    };


    return (
        <>
            <div className="d-flex align-items-center">{renderSmileys()}</div>
        </>
    )
}
// Star Question
const StarRankOptions = (props) => {
    const { selectedQuestion, selectedOption, onChange } = props;
    const [value, setValue] = useState(selectedOption);

    const handleRatingChange = (value) => {
        setValue(value);
        onChange(value);

    };

    const renderStars = () => {
        const stars = [];
        for (let i = 1; i <= selectedQuestion.rateMax; i++) {
            stars.push(
                <Button
                    key={i}
                    variant="light"
                    className="mx-1"
                    onClick={() => handleRatingChange(i)}

                >
                    <i
                        className={`bi bi-star${parseInt(selectedOption) >= i ? "-fill" : ""} text-warning`}
                    ></i>
                </Button>
            );
        }
        return stars;
    };
    return (
        <>
            <div className="d-flex align-items-center">{renderStars()}</div>
        </>
    )
}


//slider question
const SliderQuestion = (props) => {
    const { selectedQuestion, selectedOption, onChange } = props;
    const [valueInput, setValueInput] = useState(selectedOption);

    const [value, setValue] = useState(selectedQuestion.minValue);

    const handleInputChange = (event) => {
        const newValue = parseInt(event.target.value);
        setValue(newValue);
        onChange(newValue);
    };
    const sliderStyle = {
        width: "100%",
        background:
            "linear-gradient(to right, #87CEFA, #87CEFA " +
            ((value - selectedQuestion.minValue) / (selectedQuestion.maxValue - selectedQuestion.minValue)) * 100 +
            "%, #f5f5f5 " +
            ((value - selectedQuestion.minValue) / (selectedQuestion.maxValue - selectedQuestion.minValue)) * 100 +
            "%, #f5f5f5)",
    };

    const handleDecreaseClick = () => {
        const newValue = value - selectedQuestion.step;
        if (newValue >= selectedQuestion.minValue) {
            setValue(newValue);
        }
    };

    const handleIncreaseClick = () => {
        const newValue = value + selectedQuestion.step;
        if (newValue <= selectedQuestion.maxValue) {
            setValue(newValue);
        }
    };
    return (
        <>
            <div style={{ width: '100%' }}>

                <div className="d-flex align-items-center">
                    <div className="col-1">
                        <Button variant="outline-secondary" onClick={handleDecreaseClick}>
                            -
                        </Button>
                    </div>
                    <div className="justify-content-center mb-3 align-items-center col-10">
                        <div className="text-center">
                            <div className="mx-2">{valueInput || value}</div>
                            <input
                                type="range"
                                name={selectedQuestion.name}
                                id={selectedQuestion.name}
                                min={selectedQuestion.minValue}
                                max={selectedQuestion.maxValue}
                                step={selectedQuestion.step}
                                value={valueInput || value}
                                onChange={handleInputChange}
                                className="form-control-range"
                                style={sliderStyle}
                            />
                        </div>
                    </div>

                    <div className="col-1">
                        <Button variant="outline-secondary" onClick={handleIncreaseClick}>
                            +
                        </Button>
                    </div>
                </div>

            </div>
        </>
    )
}


//Date Question
const DateOptions = (props) => {
    const { selectedQuestion, selectedOption, onChange } = props;

    const [value, setValue] = useState(new Date(selectedOption)); // Convert selectedOption to a Date object

    const handleOptionChange = (event) => {
        setValue(event.value); // Update the selected date in the state
        onChange(event.value.toLocaleDateString('en-US')); // Call the onChange callback with the formatted date
    };

    return (
        <>
            <div className="col-5" style={{ padding: 0 }}>
                <div className='custom-calender'>
                    <Calendar
                        value={value}
                        onChange={handleOptionChange}
                        placeholder="Example Date"
                        name="exampleDate"
                        showIcon={true}
                        showButtonBar={true}
                    />
                </div>
            </div>
        </>
    );
};

// question which has with text and value as props for options
const MultiselectDropdownWithValue = ({ selectedQuestion, onChange, selectedOption, dataIndex }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedChoices, setSelectedChoices] = useState([]);

    useEffect(() => {
        if (selectedOption && Array.isArray(selectedOption)) {
            setSelectedChoices(selectedOption);
        }
    }, [selectedOption]);

    const handleSelectOption = (event) => {
        const selectedValue = event.target.value;
        const selectedArray = [...selectedChoices];
        if (selectedArray.includes(selectedValue)) {
            selectedArray.splice(selectedArray.indexOf(selectedValue), 1);
        } else {
            selectedArray.push(selectedValue);
        }
        setSelectedChoices(selectedArray);
        onChange(selectedArray, dataIndex);
    };
    // const handleSelectOption = useCallback(
    //     (event) => {
    //       const selectedValue = event.target.value;
    //       const selectedArray = [...selectedChoices];
    //       if (selectedArray.includes(selectedValue)) {
    //         selectedArray.splice(selectedArray.indexOf(selectedValue), 1);
    //       } else {
    //         selectedArray.push(selectedValue);
    //       }
    //       setSelectedChoices(selectedArray);
    //       onChange(selectedArray,dataIndex);
    //     },
    //     [selectedChoices, onChange]
    //   );

    const handleToggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    const handleSelectAll = () => {
        const allValues = selectedQuestion.choices.map((choice) => choice.value);
        setSelectedChoices(allValues);
        onChange(allValues);

    };

    const handleDeselectAll = () => {
        setSelectedChoices([]);
    };

    const sortedChoices = selectedQuestion.choices
        .slice()
        .sort((a, b) => a.text.localeCompare(b.text))
        .reduce(
            (acc, choice) => {
                if (selectedChoices.includes(choice.value)) {
                    acc.selected.push(choice);
                } else {
                    acc.unselected.push(choice);
                }
                return acc;
            },
            { selected: [], unselected: [] }
        );

    const allChoices = sortedChoices.selected.concat(sortedChoices.unselected);

    const maxWebChoices = 3;

    return (

        <Dropdown
            style={{ width: '80%' }}
            show={showDropdown}
            onToggle={handleToggleDropdown}
        >
            <Dropdown.Toggle
                variant="secondary"
                className="w-100"
                id={`${selectedQuestion.name}-dropdown`}
                style={{
                    backgroundColor: "white",
                    color: "black",
                    maxWidth: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    textAlign: "left",
                }}
            >
                {selectedChoices.length === 0 && (
                    <span>Select an option</span>
                )}
                {selectedChoices.length > 0 && selectedChoices.length <= maxWebChoices && (
                    <span>
                        {selectedChoices.map((selected) => (
                            <Badge
                                key={selected}
                                variant="secondary"
                                className="mr-1 mb-1 selected-choice" // Add the CSS class "selected-choice"
                                onClick={() => handleSelectOption({ target: { value: selected } })}
                            >
                                {selected} <i className="fa fa-times-circle ml-1"></i>
                            </Badge>
                        ))}
                    </span>
                )}

                {selectedChoices.length > maxWebChoices && (
                    <span>
                        {`${selectedChoices.length} items selected`}
                    </span>
                )}
            </Dropdown.Toggle>
            <Dropdown.Menu
                className="w-100"
                style={{
                    minWidth: "200px",
                    maxHeight: "300px",
                    overflowY: "auto",
                    padding: "0.5rem",
                }}
            >
                <div className="mb-2 d-flex align-items-center">
                    <Form.Check
                        type="checkbox"
                        label="Select All"
                        onChange={handleSelectAll}
                        checked={selectedChoices.length === allChoices.length}
                    />
                </div>
                {allChoices.map((choice) => (
                    <div
                        key={choice.value}
                        className="d-flex align-items-center justify-content-between w-100"
                    >
                        <label htmlFor={`checkbox-${choice.value}`} className="w-100">
                            <Form.Check
                                type="checkbox"
                                label={choice.text}
                                value={choice.value}
                                id={`checkbox-${choice.value}`}
                                onChange={handleSelectOption}
                                checked={selectedChoices.includes(choice.value)}
                            />
                        </label>
                    </div>
                ))}
            </Dropdown.Menu>
        </Dropdown>

    );
};

// Boolean question

const BooleanDropdown = ({ selectedQuestion, onChange, selectedOption }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedChoices, setSelectedChoices] = useState(selectedOption || []);

    useEffect(() => {
        setSelectedChoices(selectedOption || []);
    }, [selectedOption]);

    const handleToggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    const handleSelectOption = (choice) => {
        let updatedChoices = [...selectedChoices];

        if (updatedChoices.includes(choice)) {
            // Remove the choice if it already exists in the array
            updatedChoices = updatedChoices.filter((c) => c !== choice);
        } else {
            // Add the choice to the array
            updatedChoices.push(choice);
        }

        setSelectedChoices(updatedChoices);
        onChange(updatedChoices);
    };

    return (
        <Dropdown style={{ width: '80%' }} show={showDropdown} onToggle={handleToggleDropdown}>
            <Dropdown.Toggle
                variant="secondary"
                className="w-100"
                id={`${selectedQuestion.name}-dropdown`}
                style={{
                    backgroundColor: 'white',
                    color: 'black',
                    maxWidth: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    textAlign: 'left',
                }}
            >
                {selectedChoices.length > 0 ? selectedChoices.join(', ') : 'Select an option'}
            </Dropdown.Toggle>
            <Dropdown.Menu className="w-100">
                <div
                    className="d-flex align-items-center justify-content-between w-100"
                    onClick={() => handleSelectOption(selectedQuestion.labelTrue)}
                >
                    <label className="w-100">
                        <Form.Check
                            type="checkbox"
                            label={selectedQuestion.labelTrue}
                            value={selectedQuestion.labelTrue}
                            checked={selectedChoices.includes(selectedQuestion.labelTrue)}
                            onChange={() => { }}
                        />
                    </label>
                </div>
                <div
                    className="d-flex align-items-center justify-content-between w-100"
                    onClick={() => handleSelectOption(selectedQuestion.labelFalse)}
                >
                    <label className="w-100">
                        <Form.Check
                            type="checkbox"
                            label={selectedQuestion.labelFalse}
                            value={selectedQuestion.labelFalse}
                            checked={selectedChoices.includes(selectedQuestion.labelFalse)}
                            onChange={() => { }}
                        />
                    </label>
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default DisplayLogicQuestion;
